import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BannerSectionModel } from 'simpo-component-library/lib/sections/banner-section/banner-section.model';
import { ServiceSectionModal } from 'simpo-component-library/lib/sections/service-section/service-section.model';
import { TextSectionModel } from 'simpo-component-library/lib/sections/text-section/text-section.model';
import { alignmentTabs, animationSpeed, animationTypes, height, spacing, tabs } from './floating-editor.modal';
import { DomSanitizer } from '@angular/platform-browser';
// import { EventsService } from 'simpo-component-library';
import { Subscription } from 'rxjs';
import { EventEmmiterService } from 'simpo-components';
import { TemplateService } from 'src/app/services/template.service';
import { EventsService } from 'src/app/services/events.service';
import { TemplateMasterService } from '../../../template-master.service';
// import { EventEmmiterService } from 'src/app/services/event-emmiter.service';
@Component({
  selector: 'app-floating-editor',
  templateUrl: './floating-editor.component.html',
  styleUrls: ['./floating-editor.component.scss']
})
export class FloatingEditorComponent implements OnInit, OnChanges {
 @Input() data!: TextSectionModel | BannerSectionModel | ServiceSectionModal;
  @Input() templatePage: any[] = [];
  @Input() currentPageIndex: number = 0;
  editorDirection: 'LEFT' | 'RIGHT' = 'RIGHT';
  @Output() editorDirectionEvent: EventEmitter<'LEFT' | 'RIGHT'> = new EventEmitter<'LEFT' | 'RIGHT'>();
  @Output() dismissEvent: EventEmitter<any> = new EventEmitter();




  // tabs = tabs;
  tabs = [
    { name: 'CONTENT', status: true },
    { name: 'STYLES', status: false }
  ];

  alignmentTabs = alignmentTabs;
  animationTypes = animationTypes;
  animationSpeed = animationSpeed;
  spacing = spacing;
  height = height;
  selecteAnimation: string = animationTypes[0].type;
  selectedTab: string = 'CONTENT';
  Object = Object;
  carouselBanner: boolean = false;



  constructor(
    public ds: DomSanitizer,
    public eventEmitter: EventsService,
    private eventHelper: EventEmmiterService,
    private eventEmitterService: EventEmmiterService,
    private eventEmitters: TemplateService,
    private templateService: TemplateMasterService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    //  this.data = res.data;
      this.contentData = this.data.content;
      // this.sectionIndex = res?.index ?? -1;
      this.carouselBanner = false;
      this.activeTab = 'STYLE';
  }
  activeTab: any = 'STYLE';

  tabsHeading: any = {
    'STYLE': '',
    'LIST_ITEM': 'Item',
    'LOGO_EDITOR': 'Logo',
    'SOCIAL_CHANNEL': 'Social Link',
    'BACKGROUND': 'Colors',
    'BUTTON_STYLE': 'Button style',
    'DIVIDER' : 'Divider',
    'IMAGE_EDITOR': 'Image',
    'BUTTON_EDITOR': 'Button'
  }


  contentData: any;
  sectionIndex: number = -1;
  private emiterSubscriber: Subscription | undefined;
  private currentTabSubscriber?: Subscription;
  editorData: any;
  ngOnInit(): void {
    this.emiterSubscriber = this.eventEmitter.editSection.subscribe((res:any) => {
      this.data = res.data;
      this.contentData = this.data.content;
      this.sectionIndex = res?.index ?? -1;
      this.carouselBanner = false;
      this.activeTab = 'STYLE';
    });

    this.currentTabSubscriber = this.templateService.secondaryEditor.subscribe((res: any) => {
      this.activeTab = res?.data?.tab;
      this.editorData = res?.data
      this.carouselBanner = false;
    });


    this.emiterSubscriber = this.eventHelper.editSection.subscribe((res:any)=>{
      this.data = res.data;
      this.contentData = this.data.content;
      this.sectionIndex = res?.index ?? -1;
      this.selectedTab = 'CONTENT';
      this.tabs[0].status = true;
      this.tabs[1].status = false;
      this.carouselBanner = true
    })

    this.eventEmitters.goBack.subscribe((res)=>{
      if(res?.back){
        this.activeTab = 'STYLE'
      }
    })
  }

  ngOnDestroy(): void {
      this.emiterSubscriber?.unsubscribe();
    this.currentTabSubscriber?.unsubscribe();
  }

  tabShift(tab: string) {
    this.tabs.forEach(element => {
      if (element.name === tab) {
        element.status = true;
        this.selectedTab = tab;
      } else {
        element.status = false;
      }
    });
  }

  //background image toggle
  toggleChanged(ev: any) {
    this.data.styles.background.showImage = ev.checked;
    this.eventEmitter.backgroundImageChangeCheck.emit({
      id: this.data.id,
      data: this.data.styles.background,
      type: this.data.sectionType
    });
  }

  //alignment tabs
  changeAlignmentTab(item: string) {
    // this.alignmentTabs.forEach(element => {
    //   if (element.name === item) {
    //     element.status = true;
    //     this.data.styles.layout.layoutAlignment?.value = item;
    //     this.eventEmitter.alignmentChangeChecks.emit({
    //       data: this.data.styles.layout,
    //       type:this.data.sectionType
    //     });
    //   } else {
    //     element.status = false;
    //   }
    // });
  }

  changeAnimationType() {
    this.eventEmitter.animationChangeChecks.emit({
      data: this.data.styles.animation,
      type: this.data.sectionType
    });
  }

  changeAnimationSpeed(item: any) {
    this.animationSpeed.forEach(element => {
      if (element.name === item) {
        element.status = true;
        this.data.styles.animation.speed = item;
        this.eventEmitter.animationChangeChecks.emit({
          data: this.data.styles.animation,
          type: this.data.sectionType
        });
      } else {
        element.status = false;
      }
    });
  }

  //spacing Releate functions

  spacingTop() {
    this.eventEmitter.spacingChangeChecks.emit({
      data: this.data.styles.layout,
      type: this.data.sectionType
    });
  }

  changesingleHeightTab(item: any) {
    this.height.forEach(element => {
      if (element.name === item) {
        element.status = true;
        this.data.styles.layout.fit = item;
        this.eventEmitter.spacingChangeChecks.emit({
          data: this.data?.styles.layout,
          type: this.data.sectionType
        });
      } else {
        element.status = false;
      }
    });
  }

  toggleBorder() {
    this.eventEmitter.borderChangeChecks.emit({
      data: this.data?.styles.border,
      type: this.data.sectionType
    });
  }

  atValues = [
    { id: 1, value: 'Fredrik Sundqvist', link: 'https://google.com' },
    { id: 2, value: 'Patrik Sjölin' }
  ];
  hashValues = [
    { id: 3, value: 'Fredrik Sundqvist 2' },
    { id: 4, value: 'Patrik Sjölin 2' }
  ]


  quillConfig = {
    //toolbar: '.toolbar',
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['code-block'],
        // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        //[{ 'direction': 'rtl' }],                         // text direction
        ['link'],
        // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        //[{ 'font': [] }],
        //[{ 'align': [] }],

        // ['clean'],                                         // remove formatting button

        ['link', 'image', 'video']
      ],

    },
    keyboard: {
      bindings: {
        // shiftEnter: {
        //   key: 13,
        //   shiftKey: true,
        //   handler: (range, context) => {
        //     // Handle shift+enter
        
        //   }
        // },
        enter: {
          key: 13,
          handler: (range: any, context: any) => {
            
            return true;
          }
        }
      }
    }
  };

  getOriginalObjectStructure() {
    return 0;
  }


  changeEditorDirection(ev) {

    if (ev === 'LEFT') {
      this.editorDirection = 'RIGHT';
    }
    else {
      this.editorDirection = "LEFT";
    }
    this.editorDirectionEvent.emit(this.editorDirection);
  }

  screenWidth: any;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.screenWidth = window.innerWidth;
  }


}
